import React, {memo, useCallback} from 'react';
import ConfusionMatrixCell from './ConfusionMatrixCell';

interface ConfusionMatrixRowProps {
    leftLabel: string;
    rightLabels: string[];
    labelMatrix: Record<string, Record<string, {count: number; correct: boolean}>>;
    totals: Record<string, number>;
    showPercentages: boolean;
    rowIndex: number;
    isRowHighlighted: boolean;
    hoveredCol: number | null;
    onCellHover: (rowIndex: number, colIndex: number) => void;
}

function ConfusionMatrixRow({
    leftLabel,
    rightLabels,
    labelMatrix,
    totals,
    showPercentages,
    rowIndex,
    isRowHighlighted,
    hoveredCol,
    onCellHover,
}: ConfusionMatrixRowProps): JSX.Element {
    const handleCellHover = useCallback(
        (colIndex: number) => {
            onCellHover(rowIndex, colIndex);
        },
        [rowIndex, onCellHover]
    );

    const total = totals[leftLabel] || 0;

    return (
        <div className={`c-confusionMatrix__row ${isRowHighlighted ? 'c-confusionMatrix__row--highlighted' : ''}`}>
            <div className="c-confusionMatrix__cell c-confusionMatrix__cell--rowHeader">{leftLabel}</div>
            {rightLabels.map((rightLabel, colIndex) => {
                const count = labelMatrix[leftLabel]?.[rightLabel].count || 0;
                const correct = labelMatrix[leftLabel]?.[rightLabel].correct || false;
                const percentage = total > 0 ? Math.round((count / total) * 100) : 0;

                return (
                    <ConfusionMatrixCell
                        key={colIndex}
                        count={count}
                        percentage={percentage}
                        showPercentages={showPercentages}
                        isHighlighted={hoveredCol === colIndex}
                        onMouseEnter={() => handleCellHover(colIndex)}
                        correct={correct}
                    />
                );
            })}
        </div>
    );
}

export default memo(ConfusionMatrixRow);
